import type { TFunction } from "i18next";
import { activeFilterParts, type FilterableColumn, filterValueText } from "../entity-table/columnFilters";

export const describeColumnFilters = (t: TFunction, columns: (FilterableColumn & { label: string })[]): string[] =>
  columns.flatMap((column) =>
    activeFilterParts(column).map((part) => `${column.label}: ${filterValueText(t, column, part)}`),
  );
